import React from "react";
import styles from "./Spinner.module.css"; // Ensure correct path

interface SpinnerProps {
    size?: number;
    color?: 'beige' | 'brown';
    className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 24, color = 'beige', className = '' }) => {
    return (
        <div
            style={{
                width: size,
                height: size,
            }}
            className={`${styles.spinner} ${className} ${color === 'beige' ? styles.beige : styles.brown}`} // Apply the CSS class
        />
    );
};

export default Spinner;
